module.exports = __webpack_public_path__ + "img/Desk Stationary A18.231d8f6b.jpg";